import { render, staticRenderFns } from "./CalendarEventPlaceholder.vue?vue&type=template&id=7b2e9bcd&scoped=true"
import script from "./CalendarEventPlaceholder.vue?vue&type=script&lang=js"
export * from "./CalendarEventPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventPlaceholder.vue?vue&type=style&index=0&id=7b2e9bcd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2e9bcd",
  null
  
)

export default component.exports